window.debounce = function (fn, wait) {
  let t;
  return function (...a) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, a), wait);
  };
};

function withAlpine(cb) {
  if (window.Alpine) cb(window.Alpine);
  else document.addEventListener('alpine:init', () => cb(window.Alpine));
}

withAlpine((Alpine) => {
  Alpine.data('gaCartDrawer', (threshold) => ({
    threshold,
    open: false,
    updating: false,
    updatingKey: null,

    cart: { items: [], total_price: 0, item_count: 0 },

    // --- VAT & threshold helpers (EKLENDİ) ---
    vatRate: 0.20,                 // %20
    thresholdCents: 0,             // eşik kuruş; init()'te hesaplanır

    // ex-VAT ara toplam (kuruş)
    get subtotalExCents() { return this.cart.total_price || 0; },

    get vatCents() {
      const rate = this.vatRate; // 0.20
      return (this.cart.items || []).reduce((sum, it) => {
        const ex = it.final_line_price || 0;                 // kuruş
        const inc = Math.round(ex * (1 + rate));             // kuruş (satır bazlı yuvarlama)
        return sum + (inc - ex);                              // KDV_satır
      }, 0);
    },
    get subtotalIncCents() { return this.subtotalExCents + this.vatCents; },

    // Ücretsiz kargoya kalan (inc-VAT bazlı, kuruş)
    get remainingToFreeShipCents() {
      const remain = this.thresholdCents - this.subtotalIncCents;
      return Math.max(0, remain);
    },
    close(){
      this.open = false;
    },
    init() {
      // Liquid'ten gelen threshold pound cinsinden; kuruşa çevir
      this.thresholdCents = Math.round((Number(this.threshold) || 0) * 100);

      this.fetchCart();
      window.addEventListener('toggle-cart', () => {
        this.fetchCart();
        this.open = true;
      });
    },

    async fetchCart() {
      try {
        const data = await (await fetch('/cart.js')).json();

        this.cart.items = data.items.map((item) => ({
          key: item.key,
          id: item.variant_id,
          quantity: item.quantity,
          variant_title: item.variant_title,
          product_title: item.product_title,
          final_line_price: item.final_line_price,
          original_line_price: item.original_line_price,
          image: item.image,
          url: item.url,
          price:          item.price,
          original_price: item.original_price,
        }));
        this.cart.total_price = data.total_price; // ex-VAT kuruş
        this.cart.item_count  = data.item_count;

        window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      } catch (e) {
        console.error('[GA] fetchCart error', e);
      }
    },

    async _changeCart(key, qty) {
      this.updating = true;
      this.updatingKey = key;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        await this.fetchCart();
      } catch (e) {
        console.error('[GA] cart change error', e);
      } finally {
        this.updating = false;
        this.updatingKey = null;
      }
    },

    updateQuantity(key, q) { q < 1 ? this.removeItem(key) : this._changeCart(key, q); },
    removeItem(key) { this._changeCart(key, 0); },

    // ESKİ: pounds (görüntüleme için kalıyor; başka yerde kullanıyorsan kırılmasın)
    get subtotal() { return this.cart.total_price / 100; },

    // GÜNCEL: inc-VAT bazlı ilerleme (kuruş)
    get shippingProgress() {
      if (!this.thresholdCents) return 0;
      return Math.min((this.subtotalIncCents / this.thresholdCents) * 100, 100);
    },

    // Görüntüleme helper'ı: kuruş -> £
    formatMoney(cents) { return '£' + (cents / 100).toFixed(2); },
  }));
});

withAlpine((Alpine) => {
  Alpine.data('gaAddToCart', (cfg = {}) => ({
    selectedVariant: cfg.initialVariantId || null,
    quantity: 1,
    adding: false,
    showDynamicCheckout: cfg.showDynamicCheckout ?? true,
    showGiftCardRecipient: cfg.showGiftCardRecipient ?? false,

    decrement() { if (this.quantity > 1) this.quantity--; },
    increment() { this.quantity++; },

    buildPayload(fd) {
      const p = {};
      fd.forEach((v, k) => {
        if (v === '' || v === null) return;
        if (p[k] === undefined) p[k] = v;
        else {
          if (!Array.isArray(p[k])) p[k] = [p[k]];
          p[k].push(v);
        }
      });
      return p;
    },

    async submitForm(evt) {
      if (this.adding) return;
      this.adding = true;
      try {
        const form = evt.target.closest('form');
        if (form && this.selectedVariant) {
          const idInput = form.querySelector('[name="id"]');
          if (idInput) idInput.value = this.selectedVariant;
        }
        const payload = this.buildPayload(new FormData(form));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        window.dispatchEvent(new CustomEvent('toggle-cart'));
      } catch (e) {
        console.error('[GA] add-to-cart error', e);
      } finally {
        this.adding = false;
      }
    },
  }));
});